window.enforceMinMax = function (el) {
    if (el.value != "") {
        if (parseInt(el.value) < parseInt(el.min)) {
            el.value = el.min;
        }
        if (parseInt(el.value) > parseInt(el.max)) {
            el.value = el.max;
        }
    }
}

window.calcCustomSquareFeet = function () {
    console.log("Calculating custom square feet ...");

    // Remove all error classes
    document.querySelectorAll(".product-custom-row__col input").forEach(function (el) {
        el.classList.remove("error");
    })

    /* For IE 11+ Nodelist forEach Function */
    var elem2 = document.querySelector("[name=CalcBut]");
    var prop1 = document.querySelector("[id=size-code-description]");
    var prop2 = document.querySelector("[id=size-code]");
    var prop3 = document.querySelector("[id=cust-qty-desc]");
    var err5 = document.querySelector("[id=myerror]");

    
    if (!elem2) { return false; }

    err5.innerHTML = "";
    var variantopt1 = document.querySelector("[name=testingit]");
    var mystr = variantopt1.innerHTML;

    // var myprice = document.querySelector("[id=whlslprc]");

    // if (customerId == 1) { myprice = myprice }
    // else {
    //     myprice = document.querySelector(".price__sale .price-item--sale");
    // }

    
    var myprice = document.querySelector("sale-price2").textContent;
    myprice = myprice.match(/\$\d+(?:.\d+)?/);

    if (myprice) {
        myprice = myprice[0]
    } else {
        return false;
    }

    // var myprice2 = myprice.innerHTML;
    var myprice2 = myprice;

    mystr = mystr.substr(4, 1);

    var metafields = {};
    try {
        metafields = JSON.parse(document.querySelector("#metafieldsJson").textContent);
    } catch (error) {
        console.log(error);
    }

    var maxwidin = parseInt(document.querySelector("[id=maxwid]").value || 0) || metafields['WidLimit'];
    var maxlenin = parseInt(document.querySelector("[id=maxlen]").value || 0) || metafields['LenLimit'];
    var maxwidinr = parseInt(document.querySelector("[id=maxwidr]").value || 0) || metafields['RunWid'];
    var maxleninr = parseInt(document.querySelector("[id=maxlenr]").value || 0) || metafields['RunLen'];
    var widlistin = document.querySelector("[id=widlist]").value || metafields['WidList'] || '';
    var widlistrun = document.querySelector("[id=widlistrun]").value || metafields['WidListRun'] || '';

    var elem = document.querySelector("[name=sftotal]");
    var elem3 = document.querySelector("[name=quantity]");

    var inputLenFeet = parseInt(document.querySelector("[name=LenFeet]").value || 0);
    var input2 = parseInt(document.querySelector("[name=LenInches]").value || 0);

    var inputWidFeet = parseInt(document.querySelector("[name=WidFeet]").value || 0);
    var input4 = parseInt(document.querySelector("[name=WidInches]").value || 0);

    var inputWidFeet2 = parseInt(document.querySelector("[name=WidFeet2]").value || 0);
    var input6 = parseInt(document.querySelector("[name=WidInches2]").value || 0);

    var elem4 = document.querySelector("[name=custpricetot]");
    var elem3r = document.querySelector("[name=sftotalr]");
    var elem4r = document.querySelector("[name=custpricetotr]");
    var custlimitstxt = document.querySelector("[id=custsizeavail]").innerHTML;
    var customPriceTotal = document.querySelector("#customPriceTotal");

    // Convert feet to inches
    input2 = inputLenFeet * 12 + input2;
    input4 = inputWidFeet * 12 + input4;
    input6 = inputWidFeet2 * 12 + input6;

    var mywidlist;
    var widarray;

    var minwid = custlimitstxt.includes("Minimum");

    //if ( widlistin === null) {mywidlist = 0}
    //else {
    mywidlist = widlistin;
    //  if (widlistrun === null){mywidlist = mywidlist}
    //  else{
    mywidlist = mywidlist + "," + widlistrun;
    widarray = mywidlist.split(",");
    //  }
    var myfstval;
    var mymsg = "";
    elem.value = 0;
    elem3.value = 0;
    elem3r.value = 0;
    elem4.value = "$0";
    elem4r.value = "$0";
    customPriceTotal.innerHTML = "Your Price: $0";

    var mybool = true;
    // if (input6 == null) { input6 = 0; }
    /*else { input4 = input6 ;}*/

    if (input2 == 0 || input4 == 0 || input6 == 0) {
        mymsg = "Invalid Or Zero Dimensions, Please Check and Then Re-Calculate";

        if (input2 == 0) {
            addErrorBorders([2]);
        }
        if (input4 == 0) {
            addErrorBorders([4]);
        }
        if (input6 == 0) {
            addErrorBorders([6]);
        }
    }

    var rndsqft = 0;
    if ((parseInt(input4) + parseInt(input6)) <= parseInt(maxwidinr)) {
        if (parseInt(maxwidinr) >= 0) {
            maxlenin = maxleninr;
        }
    }

    if (widarray.length <= 2) { mywidlist = mywidlist }
    else {
        widarray = widarray.sort();
        //var mylast = widarray.length;
        //maxwidin = widarray.splice(mylast-1,mylast);
        mybool = false;
        var myval = input4;
        widarray.forEach(mycheckfunction);
        function mycheckfunction(item, index, arr) {
            if (item == myval) {
                mybool = true;
            }
        }
    }

    console.log('mybool', mybool);

    if (mybool == false) {
        rndsqft = 0;
        mymsg = "Width Must Be One Of These Values: " + widarray;
    }
    else {
        if (parseInt(input2) > parseInt(maxlenin) || (parseInt(input6) + parseInt(input4)) > parseInt(maxwidin)) {
            console.log('else if')
            mymsg = "Invalid Dimensions: ";
            if (parseInt(input2) > parseInt(maxlenin)) {
                console.log('parseInt(maxlenin) % 12', parseInt(maxlenin) % 12, parseInt(maxlenin));
                mymsg = mymsg + "Length must be <= " + (Math.floor(parseInt(maxlenin) / 12) > 0 ? (Math.floor(parseInt(maxlenin) / 12) + ' feet') : '') + (parseInt(maxlenin) % 12 > 0 ? (' and' + parseInt(maxlenin) % 12 + 'inches') : '');
                if (maxlenin == maxleninr) {
                    mymsg = mymsg + " for Runners";
                }

                addErrorBorders([2]);
            }
            if ((parseInt(input6) + parseInt(input4)) > parseInt(maxwidin)) {
                mymsg = mymsg + " Width must be <= " + (Math.floor(parseInt(maxwidin) / 12) > 0 ? (Math.floor(parseInt(maxwidin) / 12) + ' feet') : '') + (parseInt(maxwidin) % 12 > 0 ? (' and' + parseInt(maxwidin) % 12 + 'inches') : '');

                addErrorBorders([4, 6]);
            }
            mymsg = mymsg + ". Please Re-enter and Recalculate";

            input2 = 0;
            input6 = 0
            input4 = 0;
            rndsqft = 0;

        }
        else {
            if (mystr === "C") {
                rndsqft = ((parseInt(input4) + parseInt(input6)) / 12);
                rndsqft = rndsqft * rndsqft;
                var rndwidft = (parseInt(input4) + parseInt(input6)) / 12;
                rndwidft = Math.floor(rndwidft);
                var rndwidin = (parseInt(input4) + parseInt(input6)) % 12;
                prop1.value = rndwidft + "'" + rndwidin + '"';
                rndwidft = rndwidft + "";
                if (rndwidft.length == 1) { rndwidft = "0" + rndwidft; }
                rndwidin = rndwidin + "";
                if (rndwidin.length == 1) { rndwidin = "0" + rndwidin; }

                prop2.value = rndwidft + "" + rndwidin;
                prop2.value = prop2.value + " / " + prop1.value;
                prop3.value = "Quantity Equals Total Square Footage For Custom Rugs";
            }
            else {
                rndsqft = (parseInt(input2) / 12) * (parseInt(input4) / 12);
                console.log('rndsqft', rndsqft);
                var mylenft = Math.floor((parseInt(input2) / 12));
                var mywidft = Math.floor((parseInt(input4) / 12));
                var mylenin = (parseInt(input2) % 12);
                var mywidin = (parseInt(input4) % 12);
                prop1.value = mywidft + "'" + mywidin + '"x' + mylenft + "'" + mylenin + '"';

                var mywidftst = mywidft;
                var mywidinst = mywidin;
                var mylenftst = mylenft;
                var myleninst = mylenin;
                if (mywidft < 10) { mywidftst = "0" + mywidft; }
                if (mywidin < 10) { mywidinst = "0" + mywidin; }
                if (mylenft < 10) { mylenftst = "0" + mylenft; }
                if (mylenin < 10) { myleninst = "0" + mylenin; }

                if (mywidft.length == 1) { mywidftst = "0" + mywidft; }
                if (mywidin.length == 1) { mywidinst = "0" + mywidin; }
                if (mylenft.length == 1) { mylenftst = "0" + mylenft; }
                if (mylenin.length == 1) { myleninst = "0" + mylenin; }
                prop2.value = mywidftst + mywidinst + mylenftst + myleninst;
                prop2.value = prop2.value + " / " + prop1.value;
                prop3.value = "Quantity Equals Total Square Footage For Custom Rugs";
            }

            console.log('rndsqft', rndsqft);

            rndsqft = Math.round(rndsqft);
            elem.value = rndsqft;
            elem3.value = rndsqft;
            elem3r.value = rndsqft;

            var myprlen = myprice2.indexOf("$") + 1;
            myprice2 = myprice2.substr(myprlen);
            myprice2 = parseFloat(myprice2);
            myprice2 = myprice2 * rndsqft;
            myprice2 = myprice2.toFixed(2);
            elem4.value = "$" + myprice2;
            elem4r.value = "$" + myprice2;
            customPriceTotal.innerHTML = "Your Price: $" + myprice2;
        }
    }

    console.log('mymsg', mymsg);
    if (minwid == true && rndsqft < 15 && mymsg == "") {
        rndsqft = 0;
        input2 = 0;
        input6 = 0
        input4 = 0;

        mymsg = "Must Be At Least 15 Square Feet, Please Enter Valid Dimensions";

        addErrorBorders([2, 4, 6]);
    }

    if (rndsqft != 0) {
        // document.querySelector(".product-custom-hideaddcart").style.display = "block";
        err5.innerHTML = "You may now add this to your cart.  *Note: The Quantity will equal the Square footage shown above";
    }
    else {
        // document.querySelector(".product-custom-hideaddcart").style.display = "none";
        err5.innerHTML = mymsg;
    }
}

function addErrorBorders(elemNumbers) {
    var pairs = {
        '2': ['LenInches', 'LenFeet'],
        '4': ['WidInches', 'WidFeet'],
        '6': ['WidInches2', 'WidFeet2']
    };

    elemNumbers.forEach(function (elemNum) {
        var elemNames = pairs[elemNum];
        elemNames.forEach(function (elemName) {
            document.querySelector("[name=" + elemName + "]").classList.add("error");
        })
    })
}
